// Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
import axios from 'axios';

const URL_INTERNA = '/guardias/guardias';
export const URL = '/api_publica/v1/guardias/guardias';
export const URL_GUARDIAS_CALENDAR = `${URL}/calendar`;

export default {
  infoHorarios(fecha, options) {
    const opts = options || {};
    const defaultParams = { fecha };
    opts.params = Object.assign(defaultParams, opts.params);
    return axios.get(`${URL_INTERNA}/horarios`, opts);
  },
  save(datos, options) {
    return axios.post(`${URL_INTERNA}`, datos, options);
  },
  destroy(id, options) {
    return axios.delete(`${URL}/${id}`, options);
  },
  infoEstadisticas(fechaInicio, fechaFin) {
    return axios.get('/guardias/consultas/info_estadisticas', {
      params: {
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
      },
    });
  },
};
